// Idempotency-Key helper for money-moving refund submits (guardrail #237).
// The server dedupes on this key: a duplicate submit (double-click / retry)
// replays the first result instead of issuing a second refund.
export function newIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  return 'idem-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10)
}
